module.exports = __webpack_public_path__ + "components/country-flag/static/ve-2d66184ba6da6528b7b8a825d3eeb117.svg";